export class SendEmail {
  nn = null;
  np1 = null;
  ne = null;
  ny = null;
}
